import styled from "styled-components";

export const StyledWalletMainWhitelistWrapper = styled.div`
  .wallet-main-whitelist-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;

    &__create {
      display: inline-grid;
      align-items: center;
      justify-content: end;
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;

      &__create {
        justify-content: start;
      }
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }

  .wallet-whitelist {
    &__head, &__row {
      grid-template-columns: 100px minmax(0, 100px) minmax(0, 200px) minmax(100px, 250px) minmax(250px, 1.5fr)  minmax(250px, 1.5fr) 100px;
    }

    &__actions {
      display: grid;
      grid-template-columns: max-content;
      grid-gap: 25px;
    }
  }
`;